// src/context/ProductContext.tsx
import React, { createContext, useState, useContext, ReactNode } from 'react';

// Define the shape of a Product
export interface Product {
  id: string;
  image: string;
  name: string;
  size: string;
  price: number;
  stock: number;
  sold: number;
  category: string;
  rating: number;
  reviewCount: number;
}

// Define the shape of the context value
interface ProductContextType {
  products: Product[];
  addProduct: (product: Product) => void;
}

// Create the context
const ProductContext = createContext<ProductContextType | undefined>(undefined);

// Create a provider component
export const ProductProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [products, setProducts] = useState<Product[]>([]); // Initialize with an empty array

  const addProduct = (product: Product) => {
    setProducts((prevProducts) => [...prevProducts, product]);
  };

  return (
    <ProductContext.Provider value={{ products, addProduct }}>
      {children}
    </ProductContext.Provider>
  );
};

// Custom hook to use the ProductContext
export const useProducts = () => {
  const context = useContext(ProductContext);
  if (context === undefined) {
    throw new Error('useProducts must be used within a ProductProvider');
  }
  return context;
};